import React from 'react';

export default function MainMenu({ onStart, onTournament, onTwoPlayer }) {
  return (
    <div className="main-menu">
      <div className="ps-particles">
        <div className="ps-particle p1" />
        <div className="ps-particle p2" />
        <div className="ps-particle p3" />
        <div className="ps-particle p4" />
      </div>
      <div className="menu-logo">
        <div className="ps-symbols">
          <span className="ps-sym tri">△</span>
          <span className="ps-sym cir">○</span>
          <span className="ps-sym crs">✕</span>
          <span className="ps-sym sqr">□</span>
        </div>
        <div className="logo-ball">⚽</div>
        <h1>FUTBOL OYUNU</h1>
        <div className="logo-line" />
        <p className="subtitle">PlayStation Edition</p>
      </div>
      <div className="menu-buttons">
        <button className="menu-btn player-btn" onClick={() => onStart('player')}>
          <div className="ps-btn-badge tri-badge">△</div>
          <span className="btn-icon">🏃</span>
          Oyuncu Modu
          <span className="btn-desc">Sahada oyna, gol at!</span>
        </button>
        <button className="menu-btn goalkeeper-btn" onClick={() => onStart('goalkeeper')}>
          <div className="ps-btn-badge sqr-badge">□</div>
          <span className="btn-icon">🧤</span>
          Kaleci Modu
          <span className="btn-desc">Kaleyi koru, kurtarış yap!</span>
        </button>
        <button className="menu-btn tournament-btn" onClick={() => onTournament('player')}>
          <div className="ps-btn-badge cir-badge">○</div>
          <span className="btn-icon">🏆</span>
          Turnuva
          <span className="btn-desc">Kupayı kazanmak için yarış!</span>
        </button>
        <button className="menu-btn" style={{background:'linear-gradient(135deg,#1a1a2e,#16213e)'}} onClick={onTwoPlayer}>
          <div className="ps-btn-badge" style={{background:'#aa44ff',color:'#fff'}}>2P</div>
          <span className="btn-icon">🎮</span>
          2 Oyuncu
          <span className="btn-desc">İki kumanda ile arkadaşınla oyna!</span>
        </button>
      </div>
      <div className="menu-footer">
        <div className="ps-footer-hint">
          <span className="ps-hint-btn">✕</span> Seç
          <span className="ps-hint-btn" style={{marginLeft: 20}}>○</span> Geri
        </div>
        <span>v3.0 PlayStation Edition</span>
      </div>
    </div>
  );
}
